// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Nn-z","badgeLink":"On-z","category":"Pn-z"};